"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.HtmlPreviewComponent = void 0;
const T = __importStar(require("@microsoft/fast-element"));
require("./template.html");
const client_1 = require("@rws-framework/client");
const events_1 = require("../../../event/events");
//@ts-ignore                
let rwsTemplate = T.html `<div class="html-preview ${x => x.isPopupMode ? 'popup-mode' : ''}">    
    ${T.when(x => x.loading, T.html `
        <div class="loading-container">
            <div class="loading-spinner"></div>
            <span class="loading-text">Loading HTML preview...</span>
        </div>
    `)}
    
    ${T.when(x => x.error, T.html `
        <div class="error-container">
            <div class="error-icon">⚠️</div>
            <div class="error-message">${x => x.error}</div>
            <button class="retry-button" @click="${x => x.refresh()}">
                <i class="simple-icon-refresh"></i>
                Retry
            </button>
        </div>
    `)}
    
    ${T.when(x => !x.loading && !x.error && x.htmlContent, T.html `
        <div class="preview-container">
            <div class="preview-toolbar">                        
                <div class="toolbar-group">
                    <button class="toolbar-button" @click="${x => x.zoomOut()}" title="Zoom out">
                        <i class="simple-icon-minus"></i>
                    </button>
                    <span class="zoom-indicator">${x => Math.round(x.scale * 100)}%</span>
                    <button class="toolbar-button" @click="${x => x.zoomIn()}" title="Zoom in">
                        <i class="simple-icon-plus"></i>
                    </button>
                    <button class="toolbar-button" @click="${x => x.resetZoom()}" title="Reset zoom">
                        <i class="simple-icon-target"></i>
                    </button>
                </div>
                
                <div class="toolbar-group">
                    <button class="toolbar-button" @click="${x => x.toggleFullscreen()}" title="${x => x.isFullscreen ? 'Exit fullscreen' : 'Enter fullscreen'}">
                        <i class="${x => x.isFullscreen ? 'simple-icon-size-actual' : 'simple-icon-size-fullscreen'}"></i>
                    </button>
                    <button class="toolbar-button popup-button ${x => x.isPopupMode ? 'active' : ''}" 
                            @click="${(x, c) => { c.event.stopPropagation(); x.togglePopup(); }}" 
                            title="${x => x.isPopupMode ? 'Close popup' : 'Open in popup'}">
                        <i class="simple-icon-${x => x.isPopupMode ? 'close' : 'frame'}"></i>
                    </button>
                    <button class="toolbar-button download-button" @click="${x => x.downloadHtml()}" title="Download HTML file">
                        <i class="simple-icon-cloud-download"></i>
                    </button>
                    <button class="toolbar-button" @click="${x => x.refresh()}" title="Refresh preview">
                        <i class="simple-icon-refresh"></i>
                    </button>                
                </div>
            </div>
            
            <div class="iframe-preview-container">
                <iframe class="html-preview-iframe" 
                        sandbox="allow-same-origin allow-scripts allow-popups allow-forms" 
                        srcdoc="${x => x.getIframeContent()}" 
                        style="transform: scale(${x => x.scale}); transform-origin: 0 0; width: ${x => (100 / x.scale)}%; height: ${x => (100 / x.scale)}%;"></iframe>
            </div>
        </div>
    `)}
    
    ${T.when(x => !x.loading && !x.error && !x.htmlContent, T.html `
        <div class="empty-state">
            <div class="empty-icon">🌐</div>
            <div class="empty-message">No HTML content to preview</div>
        </div>
    `)}
</div>
`;
require("./styles/layout.scss");
const styles = T.css `.html-preview {
  display: block;
  width: 100%;
  height: 100%;
  min-height: 300px;
}
.html-preview .preview-container {
  display: flex;
  flex-direction: column;
  height: 100%;
}
.html-preview .loading-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 2rem;
  gap: 1rem;
}
.html-preview .loading-container .loading-spinner {
  width: 24px;
  height: 24px;
  border: 2px solid #e0e0e0;
  border-top: 2px solid #007acc;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}
.html-preview .loading-container .loading-text {
  color: #666;
  font-size: 0.9rem;
}
.html-preview .error-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 2rem;
  gap: 1rem;
  background-color: #fff5f5;
  border: 1px solid #fed7d7;
  border-radius: 8px;
}
.html-preview .error-container .error-icon {
  font-size: 2rem;
}
.html-preview .error-container .error-message {
  color: #e53e3e;
  text-align: center;
  font-size: 0.9rem;
}
.html-preview .error-container .retry-button {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.5rem 1rem;
  background-color: #007acc;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 0.9rem;
  transition: background-color 0.2s;
}
.html-preview .error-container .retry-button:hover {
  background-color: #005a9e;
}
.html-preview .error-container .retry-button i {
  font-size: 0.8rem;
}
.html-preview .preview-container {
  display: flex;
  flex-direction: column;
  height: 100%;
}
.html-preview .preview-container .preview-toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0.5rem;
  background-color: #f5f5f5;
  border-bottom: 1px solid #e0e0e0;
  gap: 1rem;
}
.html-preview .preview-container .preview-toolbar .toolbar-group {
  display: flex;
  align-items: center;
  gap: 0.25rem;
}
.html-preview .preview-container .preview-toolbar .toolbar-button {
  display: flex;
  align-items: center;
  gap: 0.25rem;
  padding: 0.25rem 0.5rem;
  background-color: transparent;
  border: 1px solid #d0d0d0;
  border-radius: 4px;
  cursor: pointer;
  font-size: 0.8rem;
  transition: all 0.2s;
}
.html-preview .preview-container .preview-toolbar .toolbar-button:hover {
  background-color: #e0e0e0;
}
.html-preview .preview-container .preview-toolbar .toolbar-button.active {
  background-color: #007acc;
  color: white;
  border-color: #007acc;
}
.html-preview .preview-container .preview-toolbar .toolbar-button.close-button:hover {
  background-color: #ff6b6b;
  color: white;
  border-color: #ff6b6b;
}
.html-preview .preview-container .preview-toolbar .toolbar-button.download-button:hover {
  background-color: #28a745;
  color: white;
  border-color: #28a745;
}
.html-preview .preview-container .preview-toolbar .toolbar-button.popup-button:hover {
  background-color: #6f42c1;
  color: white;
  border-color: #6f42c1;
}
.html-preview .preview-container .preview-toolbar .toolbar-button.popup-button.active {
  background-color: #6f42c1;
  color: white;
  border-color: #6f42c1;
}
.html-preview .preview-container .preview-toolbar .toolbar-button i {
  font-size: 0.7rem;
}
.html-preview .preview-container .preview-toolbar .zoom-indicator {
  font-size: 0.8rem;
  color: #666;
  min-width: 35px;
  text-align: center;
}
.html-preview .preview-container .iframe-preview-container {
  flex: 1;
  position: relative;
  overflow: auto;
  background-color: white;
  border: 1px solid #e0e0e0;
}
.html-preview .preview-container .iframe-preview-container .html-preview-iframe {
  border: none;
  display: block;
  transform-origin: top left;
  transition: transform 0.2s ease;
  min-height: 100%;
  background-color: white;
}
.html-preview .empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 2rem;
  gap: 1rem;
  color: #999;
}
.html-preview .empty-state .empty-icon {
  font-size: 3rem;
  opacity: 0.5;
}
.html-preview .empty-state .empty-message {
  font-size: 0.9rem;
  text-align: center;
}
.html-preview .popup-mode .preview-container {
  max-width: 80%;
  margin: 0 auto;
  background-color: #fff;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}`;
const shadowOptions = { "mode": "open" };
let HtmlPreviewComponent = class HtmlPreviewComponent extends client_1.RWSViewComponent {
    constructor() {
        super(...arguments);
        this.htmlContent = '';
        this.componentId = '';
        this.error = null;
        this.loading = false;
        this.scale = 1;
        this.previewElement = null;
        this.isFullscreen = false;
        this.isPopupMode = false;
        // Track when we request fullscreen to handle shadow DOM detection
        this.fullscreenRequested = false;
        this.handleFullscreenChange = () => {
            var _a;
            const previewContainer = (_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector('.preview-container');
            const currentFullscreenElement = document.fullscreenElement ||
                document.webkitFullscreenElement ||
                document.mozFullScreenElement ||
                document.msFullscreenElement;
            if (!currentFullscreenElement) {
                // No element is in fullscreen, so we definitely exited
                this.isFullscreen = false;
            }
            else {
                // For RWS components in shadow DOM, we need to check if we're the component
                // that initiated the fullscreen request. Since shadow DOM boundaries prevent
                // contains() from working, we'll track this differently.
                // If there's a fullscreen element and we previously requested fullscreen,
                // assume we're in fullscreen. The exitFullscreen method will reset this.
                if (this.isFullscreen || this.fullscreenRequested) {
                    this.isFullscreen = true;
                    this.fullscreenRequested = false;
                }
                else {
                    // Some other element is in fullscreen
                    this.isFullscreen = false;
                }
            }
        };
        this.handleWindowResize = () => {
            // Window resize handling - CSS height: 100% should handle container sizing
        };
        this.handleOutsideClick = (event) => {
            var _a;
            const target = event.target;
            const previewContainer = (_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector('.html-preview');
            // Check if the click is outside the preview component
            if (previewContainer && !previewContainer.contains(target) && !this.contains(target)) {
                this.closePopup();
            }
        };
        this.handleEscapeKey = (event) => {
            if (event.key === 'Escape') {
                if (this.isFullscreen) {
                    this.exitFullscreen();
                }
                else if (this.isPopupMode) {
                    this.closePopup();
                }
            }
        };
    }
    async connectedCallback() {
        super.connectedCallback();
        // Render preview if htmlContent is already set
        if (this.htmlContent) {
            this.renderPreview();
        }
        // Add fullscreen change event listeners
        document.addEventListener('fullscreenchange', this.handleFullscreenChange);
        document.addEventListener('webkitfullscreenchange', this.handleFullscreenChange);
        document.addEventListener('mozfullscreenchange', this.handleFullscreenChange);
        document.addEventListener('MSFullscreenChange', this.handleFullscreenChange);
        // Add window resize event listener to ensure proper height matching
        window.addEventListener('resize', this.handleWindowResize);
    }
    disconnectedCallback() {
        super.disconnectedCallback();
        // Remove fullscreen change event listeners
        document.removeEventListener('fullscreenchange', this.handleFullscreenChange);
        document.removeEventListener('webkitfullscreenchange', this.handleFullscreenChange);
        document.removeEventListener('mozfullscreenchange', this.handleFullscreenChange);
        document.removeEventListener('MSFullscreenChange', this.handleFullscreenChange);
        // Remove window resize event listener
        window.removeEventListener('resize', this.handleWindowResize);
        // Clean up other event listeners
        document.removeEventListener('click', this.handleOutsideClick);
        document.removeEventListener('keydown', this.handleEscapeKey);
    }
    htmlContentChanged(oldValue, newValue) {
        if (newValue !== oldValue) {
            this.renderPreview();
        }
    }
    renderPreview() {
        if (!this.htmlContent)
            return;
        try {
            // Clear any previous errors
            this.error = null;
            // The iframe will automatically update due to reactive binding
            // Force a re-render by triggering observable change
            this.htmlContent = this.htmlContent;
        }
        catch (err) {
            console.error('Error rendering HTML preview:', err);
            this.error = `Failed to render HTML preview: ${err.message}`;
        }
    }
    getIframeContent() {
        if (!this.htmlContent)
            return '';
        // If it's already a complete HTML document, return as is
        if (this.isCompleteHtmlDocument(this.htmlContent)) {
            return this.htmlContent;
        }
        // Otherwise, create a complete HTML document
        return this.createCompleteHtmlDocument(this.htmlContent);
    }
    isCompleteHtmlDocument(content) {
        const trimmed = content.trim().toLowerCase();
        return trimmed.startsWith('<!doctype html') || trimmed.startsWith('<html');
    }
    extractStylesFromHtml(html) {
        // Extract content between <style> tags
        const styleRegex = /<style[^>]*>([\s\S]*?)<\/style>/gi;
        let styles = '';
        let match;
        while ((match = styleRegex.exec(html)) !== null) {
            styles += match[1] + '\n';
        }
        // Also extract CSS from <link> tags (though we can't load external files for security)
        const linkRegex = /<link[^>]*rel=["']stylesheet["'][^>]*>/gi;
        const linkMatches = html.match(linkRegex);
        if (linkMatches) {
            // Add a comment about external stylesheets
            styles += '/* External stylesheets are not loaded for security reasons */\n';
        }
        return styles;
    }
    extractBodyFromHtml(html) {
        // If it's a complete HTML document, extract body content
        const bodyMatch = html.match(/<body[^>]*>([\s\S]*?)<\/body>/i);
        if (bodyMatch) {
            return bodyMatch[1];
        }
        // If no body tag found, treat the entire content as body content
        // but remove style and head tags
        return html
            .replace(/<head[\s\S]*?<\/head>/gi, '')
            .replace(/<style[\s\S]*?<\/style>/gi, '')
            .replace(/<!DOCTYPE[^>]*>/gi, '')
            .replace(/<\/?html[^>]*>/gi, '')
            .replace(/<\/?head[^>]*>/gi, '')
            .replace(/<\/?body[^>]*>/gi, '')
            .trim();
    }
    zoomIn() {
        this.scale = Math.min(this.scale + 0.1, 2);
        this.updateScale();
    }
    zoomOut() {
        this.scale = Math.max(this.scale - 0.1, 0.5);
        this.updateScale();
    }
    resetZoom() {
        this.scale = 1;
        this.updateScale();
    }
    updateScale() {
        var _a;
        const iframe = (_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector('.html-preview-iframe');
        if (iframe) {
            // The iframe scaling is handled via template binding
            // Just trigger a re-render by updating the observable
            this.scale = this.scale;
        }
    }
    toggleFullscreen() {
        if (this.isFullscreen) {
            this.exitFullscreen();
        }
        else {
            this.enterFullscreen();
        }
    }
    async enterFullscreen() {
        var _a;
        const previewContainer = (_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector('.preview-container');
        if (!previewContainer)
            return;
        try {
            // Check if there's currently a fullscreen element (likely chat component)
            const currentFullscreenElement = document.fullscreenElement ||
                document.webkitFullscreenElement ||
                document.mozFullScreenElement ||
                document.msFullscreenElement;
            // Only emit fullscreen:disable if there's actually a fullscreen element
            if (currentFullscreenElement) {
                this.$emit('fullscreen:disable');
                // Wait longer for the chat fullscreen to exit before entering preview fullscreen
                await new Promise(resolve => setTimeout(resolve, 200));
            }
            // Mark that we're requesting fullscreen
            this.fullscreenRequested = true;
            if (previewContainer.requestFullscreen) {
                await previewContainer.requestFullscreen();
            }
            else if (previewContainer.webkitRequestFullscreen) {
                await previewContainer.webkitRequestFullscreen();
            }
            else if (previewContainer.mozRequestFullScreen) {
                await previewContainer.mozRequestFullScreen();
            }
            else if (previewContainer.msRequestFullscreen) {
                await previewContainer.msRequestFullscreen();
            }
            // State will be updated by handleFullscreenChange event listener
        }
        catch (err) {
            console.error('Failed to enter fullscreen:', err);
            this.isFullscreen = false;
            this.fullscreenRequested = false;
        }
    }
    async exitFullscreen() {
        try {
            if (document.exitFullscreen) {
                await document.exitFullscreen();
            }
            else if (document.webkitExitFullscreen) {
                await document.webkitExitFullscreen();
            }
            else if (document.mozCancelFullScreen) {
                await document.mozCancelFullScreen();
            }
            else if (document.msExitFullscreen) {
                await document.msExitFullscreen();
            }
        }
        catch (err) {
            console.error('Failed to exit fullscreen:', err);
        }
        finally {
            // Ensure state is reset even if exit fails
            this.isFullscreen = false;
            this.fullscreenRequested = false;
        }
    }
    refresh() {
        this.renderPreview();
    }
    closePreview() {
        // Emit event to parent code-viewer component to close preview
        this.$emit(events_1.appEvents.codeViewerClosePreview, { bubbles: true, composed: true });
    }
    downloadHtml() {
        // Create a blob with the HTML content
        const htmlContent = this.htmlContent;
        if (!htmlContent)
            return;
        // Create a complete HTML document
        const completeHtml = this.createCompleteHtmlDocument(htmlContent);
        // Generate filename with componentId prefix
        const baseFilename = 'code.html';
        const sanitizedId = this.sanitizeFilename(this.componentId);
        const filename = sanitizedId ? `${sanitizedId}_${baseFilename}` : baseFilename;
        const blob = new Blob([completeHtml], { type: 'text/html' });
        const url = URL.createObjectURL(blob);
        // Create a download link and trigger it
        const a = document.createElement('a');
        a.href = url;
        a.download = filename;
        a.style.display = 'none';
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        // Clean up the URL object
        URL.revokeObjectURL(url);
        // Emit event for analytics or other purposes
        this.$emit(events_1.appEvents.codeViewerDownloadHtml, {
            filename: filename,
            componentId: this.componentId,
            size: completeHtml.length
        }, { bubbles: true, composed: true });
    }
    sanitizeFilename(id) {
        if (!id)
            return '';
        // Remove or replace characters that are not allowed in filenames
        return id
            .replace(/[<>:"/\\|?*]/g, '_') // Replace forbidden characters with underscore
            .replace(/\s+/g, '-') // Replace spaces with hyphens
            .replace(/[^\w\-_.]/g, '') // Keep only word characters, hyphens, underscores, and dots
            .substring(0, 50); // Limit length to 50 characters
    }
    createCompleteHtmlDocument(content) {
        // Check if content is already a complete HTML document
        if (content.trim().toLowerCase().startsWith('<!doctype html') ||
            content.trim().toLowerCase().startsWith('<html')) {
            return content;
        }
        // Extract styles and body content
        const styleContent = this.extractStylesFromHtml(content);
        const bodyContent = this.extractBodyFromHtml(content);
        // Create a complete HTML document
        return `<!DOCTYPE html>
<html lang="en">
<head>
    <meta charset="UTF-8">
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <title>Code Preview</title>
    ${styleContent ? `<style>\n${styleContent}\n</style>` : ''}
</head>
<body>
${bodyContent}
</body>
</html>`;
    }
    // Popup functionality
    togglePopup() {
        this.isPopupMode = !this.isPopupMode;
        this.$emit('popup-toggle', { isPopupMode: this.isPopupMode }, { bubbles: true, composed: true });
        if (this.isPopupMode) {
            // Add event listeners with a slight delay to prevent immediate triggering
            setTimeout(() => {
                document.addEventListener('keydown', this.handleEscapeKey);
            }, 100);
        }
        else {
            // Remove event listeners
            document.removeEventListener('keydown', this.handleEscapeKey);
        }
    }
    closePopup() {
        this.isPopupMode = false;
        document.removeEventListener('click', this.handleOutsideClick);
        document.removeEventListener('keydown', this.handleEscapeKey);
    }
};
exports.HtmlPreviewComponent = HtmlPreviewComponent;
__decorate([
    client_1.attr,
    __metadata("design:type", String)
], HtmlPreviewComponent.prototype, "htmlContent", void 0);
__decorate([
    client_1.attr,
    __metadata("design:type", String)
], HtmlPreviewComponent.prototype, "componentId", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", String)
], HtmlPreviewComponent.prototype, "error", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Boolean)
], HtmlPreviewComponent.prototype, "loading", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Number)
], HtmlPreviewComponent.prototype, "scale", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", typeof (_a = typeof HTMLElement !== "undefined" && HTMLElement) === "function" ? _a : Object)
], HtmlPreviewComponent.prototype, "previewElement", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Boolean)
], HtmlPreviewComponent.prototype, "isFullscreen", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Boolean)
], HtmlPreviewComponent.prototype, "isPopupMode", void 0);
exports.HtmlPreviewComponent = HtmlPreviewComponent = __decorate([
    (0, client_1.RWSView)('html-preview', null, { template: rwsTemplate, styles, options: { shadowOptions } })
], HtmlPreviewComponent);
HtmlPreviewComponent.defineComponent();
